export class NotificationModel {
  msg: string = '';
  type: 'error' | 'warning' | 'message' | 'success' = 'message';
};
